import React from "react";
import cx from "classnames";

import { FieldQueryColumn } from "../../field-query.types";

import "./header.styles.scss";

export type FieldQueryHeaderProps = {
  className?: string;
  columns: Array<FieldQueryColumn>;
  getId: {
    headerRow: string;
    headerRowCell: (params: { cellIndex: number }) => string;
  };
};

export const Header: React.FC<FieldQueryHeaderProps> = ({ columns, className, getId }) => {
  return (
    <thead className={cx("FieldQueryHeader", className)}>
      <tr className="FieldQueryHeader__row" id={getId.headerRow}>
        {columns.map((column, columnIndex) => (
          <th
            key={column.id}
            className="FieldQueryHeader__row__cell"
            id={getId.headerRowCell({ cellIndex: columnIndex })}
          >
            {column.label}
          </th>
        ))}
      </tr>
    </thead>
  );
};
